import type { ReactNode } from 'react'
import Modal from '@/components/ui/Modal'
import Button from '@/components/ui/Button'

/**
 * A yes / no question in a small Modal. The confirm button carries the
 * mutation's `loading` so a double tap cannot fire twice, and the dialog is
 * left open until the caller closes it on success or failure.
 */
export default function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'primary',
  loading = false,
  confirmDisabled = false,
}: {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: ReactNode
  children?: ReactNode
  confirmLabel?: ReactNode
  cancelLabel?: ReactNode
  variant?: 'primary' | 'danger'
  loading?: boolean
  /** Keep the confirm button off until the caller's own precondition is met. */
  confirmDisabled?: boolean
}) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      width="max-w-sm"
      footer={
        <>
          <Button variant="outline" onClick={onClose} disabled={loading}>
            {cancelLabel}
          </Button>
          <Button variant={variant} onClick={onConfirm} loading={loading} disabled={confirmDisabled || loading}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {children && <div className="text-sm text-foreground/70">{children}</div>}
    </Modal>
  )
}
